// @ts-expect-error -- Suppresses TS and ESLint errors.
type _ = Types.Scalars;
import type * as Types from '@wirechunk/ui/api';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type MeIntercomUserTokenQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MeIntercomUserTokenQuery = {
  me: { __typename: 'User'; id: string; intercomUserToken: string | null } | null;
};

export const MeIntercomUserTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeIntercomUserToken' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomUserToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeIntercomUserTokenQuery, MeIntercomUserTokenQueryVariables>;
